<template>
  <div
    class="tvShows"
  >
    <app-loader v-if="loading" />

    <v-tabs
      v-model="activeTab"
      dark
      fixed-tabs
      color="teal lighten-1"
    >
      <v-tabs-slider color="yellow" />
      <v-tab
        v-for="tab in tabs"
        :key="tab.id"
      >
        <v-icon>{{ tab.icon }}</v-icon>
        <span class="pl-3">{{ tab.name }}</span>
      </v-tab>
    </v-tabs>


    <v-tabs-items v-model="activeTab">
      <v-tab-item
        v-for="tab in tabs"
        :key="tab.id"
        class="tab-item-element"
        lazy
      >
        <template v-if="tab.category === 'popular'">
          <app-page-title>Beliebte Serien</app-page-title>
          <app-tv-card :items="popular" />
          <v-container v-if="popular.pages !== pagePopular && popular.tvShows.length !== 0">
            <v-layout row>
              <v-flex>
                <div class="text-xs-center">
                  <v-btn
                    dark
                    large
                    flat
                    :disabled="loading"
                    :loading="loading"
                    @click="loadMore(tab.category)"
                  >
                    Mehr anzeigen...
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </template>

        <template v-else-if="tab.category === 'on_the_air'">
          <app-page-title>Momentan ausgestrahlte Se­rien</app-page-title>
          <app-tv-card :items="onTheAir" />
          <v-container v-if="onTheAir.pages !== pageOnTheAir && onTheAir.tvShows.length !== 0">
            <v-layout row>
              <v-flex>
                <div class="text-xs-center">
                  <v-btn
                    dark
                    large
                    flat
                    :disabled="loading"
                    :loading="loading"
                    @click="loadMore(tab.category)"
                  >
                    Mehr anzeigen...
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </template>

        <template v-else-if="tab.category === 'airing_today'">
          <app-page-title>Serien die heute ausgestrahlt werden</app-page-title>
          <app-tv-card :items="airingToday" />
          <v-container v-if="airingToday.pages !== pageAiringToday && airingToday.tvShows.length !== 0">
            <v-layout row>
              <v-flex>
                <div class="text-xs-center">
                  <v-btn
                    dark
                    large
                    flat
                    :disabled="loading"
                    :loading="loading"
                    @click="loadMore(tab.category)"
                  >
                    Mehr anzeigen...
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </template>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TVOverviewCard from '../../components/tvShows/TVOverviewCard.vue';
import PageTitle from '../../components/PageTitle.vue';


export default {
  components: {
    appPageTitle: PageTitle,
    appTvCard: TVOverviewCard,
  },
  data() {
    return {
      tabs: [
        {
          id: '1', name: 'Beliebt', icon: 'favorite', category: 'popular',
        },
        {
          id: '2', name: 'Im TV', icon: 'tv', category: 'on_the_air',
        },
        {
          id: '3', name: 'Heute im TV', icon: 'live_tv', category: 'airing_today',
        },
      ],
      activeTab: null,
      category: 'popular',
      pagePopular: 1,
      pageOnTheAir: 1,
      pageAiringToday: 1,
      offsetTop: 0,
    };
  },
  computed: {
    ...mapState({
      popular: state => state.quickTVSearch.popular,
      onTheAir: state => state.quickTVSearch.onTheAir,
      airingToday: state => state.quickTVSearch.airingToday,
    }),
    loading() {
      return this.$store.getters.loading;
    },
  },
  created() {
    this.$store.dispatch('getTVResults', { category: 'popular' });
    this.$store.dispatch('getTVResults', { category: 'on_the_air' });
    this.$store.dispatch('getTVResults', { category: 'airing_today' });
  },
  methods: {
    loadMore(category) {
      let page;
      switch (category) {
        case 'popular':
          this.pagePopular += 1;
          page = this.pagePopular;
          break;
        case 'on_the_air':
          this.pageOnTheAir += 1;
          page = this.pageOnTheAir;
          break;
        case 'airing_today':
          this.pageAiringToday += 1;
          page = this.pageAiringToday;
          break;
        default:
          page = 1;
          break;
      }
      this.$store.dispatch('getTVResults', { category, page });
    },
    log(event) {
      console.log(event);
    },
  },

};
</script>

<style lang="scss" scoped>

</style>
